import { HTTP_SERVER_SERVICE_UNAVAILABLE } from '../helpers/http';
import { COMMON } from '../translations';

export const SET_MAIN_DOCUMENT = 'SET_MAIN_DOCUMENT';

export const setMainDocument =
  (document, error, loading) => async (dispatch, getState) => {
    const { user } = getState();
    let maintenanceError = error;
    if (!user?.current && document?.maintenance) {
      maintenanceError = {
        status: HTTP_SERVER_SERVICE_UNAVAILABLE,
        message: COMMON.ERROR_MAINTENANCE_PAGE,
      };
    }

    dispatch({
      type: SET_MAIN_DOCUMENT,
      payload: { document, error: maintenanceError, loading },
    });
  };
